import { NavClanImg, NavHeroImg, NavInventoryImg, NavMapImg } from "@/assets"
import { NavTab } from "./helpers"

export interface INavItem {
  tab: NavTab
  labelKey: string
  icon: string
}

export const NAV_ITEMS: INavItem[] = [
  { tab: "map", labelKey: "nav.map", icon: NavMapImg },
  { tab: "hero", labelKey: "nav.hero", icon: NavHeroImg },
  { tab: "inventory", labelKey: "nav.inventory", icon: NavInventoryImg },
  { tab: "clan", labelKey: "nav.clan", icon: NavClanImg }
]
